export type NotificationsTranslation = {
  content: {
    actions: {
      back: string;
      markAllAsRead: string;
    };
    filtersTitle: string;
    noNotifications: {
      description: string;
      title: string;
    };
    pagination: {
      next: string;
      previous: string;
      summary: string;
    };
    title: string;
  };
  form: {
    actions: {
      reset: string;
      submit: string;
    };
    filters: {
      createdAfter: string;
      createdBefore: string;
      createdByMe: string;
      forMe: string;
      seen: string;
      seenOptions: {
        all: string;
        seen: string;
        unseen: string;
      };
      visibility: string;
    };
  };
  notification: {
    survey: {
      assigned: {
        content: string;
        title: string;
      };
    };
  };
};

export const notificationsTranslation: NotificationsTranslation = {
  content: {
    actions: {
      back: 'Back to Start',
      markAllAsRead: 'Mark all as read',
    },
    filtersTitle: 'Filters',
    noNotifications: {
      description: 'No notifications matching your criteria.',
      title: 'No Notifications',
    },
    pagination: {
      next: 'Next',
      previous: 'Previous',
      summary: 'Page {{current}} of {{total}} · {{count}} notifications',
    },
    title: 'All Notifications',
  },
  form: {
    actions: {
      reset: 'Reset',
      submit: 'Search',
    },
    filters: {
      createdAfter: 'Created after',
      createdBefore: 'Created before',
      createdByMe: 'Show notifications created by me',
      forMe: 'Show my notifications',
      seen: 'Status',
      seenOptions: {
        all: 'All',
        seen: 'Seen',
        unseen: 'Unseen',
      },
      visibility: 'Visibility',
    },
  },
  notification: {
    survey: {
      assigned: {
        content: 'You have been assigned to complete a survey. Please fill it out by the deadline.',
        title: 'New survey assigned',
      },
    },
  },
};
